import React, { createContext, useContext, useEffect, useState } from "react";

const InstallPromptContext = createContext();

export function InstallPromptProvider({ children }) {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [isInstalled, setIsInstalled] = useState(false);

  useEffect(() => {
    const beforeInstall = (e) => {
      // Prevent auto-mini-infobar and keep the event for our button
      e.preventDefault();
      setDeferredPrompt(e);
    };
    const onInstalled = () => setIsInstalled(true);

    window.addEventListener("beforeinstallprompt", beforeInstall);
    window.addEventListener("appinstalled", onInstalled);

    // Detect standalone (covers iOS + Android)
    const inStandalone =
      window.matchMedia?.("(display-mode: standalone)")?.matches ||
      window.navigator.standalone === true;
    if (inStandalone) setIsInstalled(true);

    return () => {
      window.removeEventListener("beforeinstallprompt", beforeInstall);
      window.removeEventListener("appinstalled", onInstalled);
    };
  }, []);

  const triggerInstall = async () => {
    if (!deferredPrompt) return false; // tells caller there’s no native prompt
    deferredPrompt.prompt();
    await deferredPrompt.userChoice;
    setDeferredPrompt(null);
    return true;
  };

  return (
    <InstallPromptContext.Provider
      value={{ deferredPrompt, setDeferredPrompt, isInstalled, triggerInstall }}
    >
      {children}
    </InstallPromptContext.Provider>
  );
}

export function useInstallPrompt() {
  return useContext(InstallPromptContext);
}
